/**
 * MoneyIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const MoneyIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M18.003 15.99c0-2.31-1.34-3.7-4.25-4.42l-2.52-.64c-1.5-.37-2.23-1.15-2.23-2.23 0-1.41 1.2-2.31 3-2.31a3.6 3.6 0 0 1 3.32 1.87 1.28 1.28 0 0 0 1.16.68 1.05 1.05 0 0 0 1.1-1.11 3.1 3.1 0 0 0-1.18-2.22 6.1 6.1 0 0 0-3.4-1.39V3a1 1 0 1 0-2 0v1.22c-2.89.28-4.75 2.09-4.75 4.68 0 2.23 1.34 3.68 4 4.33l2.54.66c1.76.45 2.56 1.2 2.56 2.4 0 1.46-1.2 2.31-3.23 2.31a4.3 4.3 0 0 1-3.62-1.73c-.5-.63-.89-.87-1.4-.87a1.12 1.12 0 0 0-1.1 1.2 3.08 3.08 0 0 0 1.2 2.14 6.57 6.57 0 0 0 3.8 1.45V22a1 1 0 1 0 2 0v-1.21c3.08-.29 5-2.1 5-4.8" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const MoneyIcon = makeIcon('MoneyIcon', MoneyIconSvg)
